import React from "react";
import "./NarrativeComponent.css";
import Paragraph from "./Paragraph";

const NarrativeComponent = ({ img, heading, text }) => {
  console.log(img);
  return (
    <div className="container">
      {img && (
        <div className="image-container">
          <img src={img} alt="Description" />
        </div>
      )}
      <div className="text-container">
        <h1>{heading}</h1>
        <Paragraph text={text} />
      </div>
    </div>
  );
};

export default NarrativeComponent;
